import React from 'react';
import { Inner } from './partials';
export var Option = function Option(props) {
  return React.createElement(Inner, {
    onClick: function onClick() {
      return props.onClick({
        id: props.id,
        label: props.label
      });
    }
  }, props.label);
};